<span [ngClass]="{ 'input-hint-mode': inputHintMode }" *ngIf="activeCurrency$ | async as ac">
  <ng-container *ngIf="currencyDisplayFormat == CURRENCY_DISPLAY_FORMAT.SYMBOL">
    {{ ac?.symbol }}
  </ng-container>
  <ng-container *ngIf="currencyDisplayFormat == CURRENCY_DISPLAY_FORMAT.CODE">
    {{ ac?.text }}
  </ng-container>
</span>
